import MarketingShell from "@/components/marketing/MarketingShell";

export default function Privacy() {
    return (
        <MarketingShell
            title="Privacy Policy — Furmais"
            description="Furmais privacy policy — how we handle your data, your projects, and your client information."
        >
            <article className="relative z-10 px-6 sm:px-10 pt-12 pb-24 max-w-3xl mx-auto prose prose-invert" data-testid="privacy-page">
                <div className="label-micro mb-3 text-[#FF4400]">Legal</div>
                <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-6">Privacy Policy</h1>
                <p className="text-zinc-400 mb-8">Last updated: May 2026</p>

                <section className="text-zinc-300 space-y-5 leading-relaxed">
                    <p>
                        Furmais is operated by RIFA Productions (Surat, Gujarat, India). This
                        policy describes how we collect, use, and protect your information when
                        you use our AI Production OS at furmais.com.
                    </p>

                    <h2 className="font-display text-2xl text-white pt-4">1. Information we collect</h2>
                    <p>
                        Account details (name, email, agency name) you provide during sign-up,
                        project briefs and assets you upload, and operational telemetry needed
                        to run the AI pipeline (stage status, error logs, usage counts).
                    </p>

                    <h2 className="font-display text-2xl text-white pt-4">2. How we use it</h2>
                    <p>
                        Strictly to deliver the service: orchestrating agents, generating outputs,
                        producing exports, billing, and improving reliability. We do not sell
                        your data and do not use your project content to train third-party
                        models.
                    </p>

                    <h2 className="font-display text-2xl text-white pt-4">3. AI providers</h2>
                    <p>
                        We use third-party model providers (Anthropic, Google, OpenAI) under
                        contractual data-use restrictions. Prompts and outputs travel to those
                        providers solely to fulfil your request.
                    </p>

                    <h2 className="font-display text-2xl text-white pt-4">4. Data retention</h2>
                    <p>
                        Project data is retained while your account is active. You may request
                        deletion of any project or your account at any time by emailing
                        <a href="mailto:support@furmais.com" className="text-[#FF4400] hover:underline mx-1">support@furmais.com</a>.
                    </p>

                    <h2 className="font-display text-2xl text-white pt-4">5. Contact</h2>
                    <p>
                        Privacy questions: <a href="mailto:support@furmais.com" className="text-[#FF4400] hover:underline">support@furmais.com</a>.
                    </p>
                </section>
            </article>
        </MarketingShell>
    );
}
